import React from 'react';

const WhiteCheckIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ style, ...props }) => (
    <svg width="16" height="16" viewBox="0 0 18 18" fill="none" aria-hidden="true" style={{ display: 'block', ...style }} {...props}>
        <path d="M4 9.5L7.2 12.7L14 5.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default WhiteCheckIcon;
